export const SUBSCRIPTION_LAYOUTS = ['Concrete', 'Minimalist', 'LoginlessFlat', 'LoginlessGrouped', 'Lavish'];

export const DEFAULT_LOGINLESS_SETTINGS: Record<string, string> = {
  pageTitle: 'Upgrade to Premium',
  planSelectionHeading: 'Select Your Plan',
  orderSummaryHeading: 'Order Summary',
  totalLabel: 'Total',
  taxNote: 'Inclusive of all taxes',
  descriptionTitle: "What's Included",
  loaderMessage: 'Oops, it seems plans are taking longer than expected to load. Thank you for your patience!',
  thankYouPageTitle: 'Subscription Successful',
  thankYouPageDescription:
    'Your subscription is active. Just log in or create your account to start enjoying your premium content.',
  continueReading: 'Continue'
};

export const DEFAULT_STANDARD_SETTINGS: Record<string, string> = {
  pageTitle: 'Discover the Power of News Subscription Plans',
  pageDescription:
    'Unlock premium news content and stay informed with our exclusive subscription plan. Get access to in-depth stories and expert analysis.',
  subscribeButton: 'Subscribe Now',
  descriptionTitle: "What's Included",
  loaderMessage: 'Oops, it seems plans are taking longer than expected to load. Thank you for your patience!',
  thankYouPageTitle: 'Thank you for placing your order!',
  thankYouPageDescription:
    'We kindly ask for your patience as we process it (approx. 15min). Please check your email for further details and updates.',
  continueReading: 'Continue Reading',
  goToProfile: 'Go to Profile',
  goToHome: 'Go to Home'
};

export const buildEffectiveSubscription = (rawSubscription: Record<string, any>, isLoginlessEnabled: boolean) => {
  const rawPageSetting: Record<string, any> = rawSubscription.pageSetting || {};
  const defaults = isLoginlessEnabled ? DEFAULT_LOGINLESS_SETTINGS : DEFAULT_STANDARD_SETTINGS;

  const effectivePageSetting: Record<string, any> = { ...defaults };

  Object.keys(rawPageSetting).forEach(key => {
    const val = rawPageSetting[key];
    // Preserve booleans (false is valid); skip only empty strings, null, undefined
    if (typeof val === 'boolean' || (val !== undefined && val !== null && val !== '')) {
      effectivePageSetting[key] = val;
    }
  });

  return { ...rawSubscription, pageSetting: effectivePageSetting };
};
